"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticlePollFlags = exports.CommentFlags = exports.SiteAdvertisingBannerType = exports.ArticleFlags = void 0;
exports.applySiteCommentVoteFlags = applySiteCommentVoteFlags;
exports.isSiteCommentDeleted = isSiteCommentDeleted;
exports.isSiteCommentHidden = isSiteCommentHidden;
exports.isSiteCommentKarmaVoted = isSiteCommentKarmaVoted;
exports.isArticlePollSingleChoice = isArticlePollSingleChoice;
exports.isArticlePollMultipleChoice = isArticlePollMultipleChoice;
exports.isArticlePollVoted = isArticlePollVoted;
exports.isArticlePollLegacy = isArticlePollLegacy;
exports.shouldShowArticlePollResults = shouldShowArticlePollResults;
exports.canVoteArticlePoll = canVoteArticlePoll;
/** Битовая маска из поля [4] ответа sl/sa — права и состояние статьи */
exports.ArticleFlags = {
    /** 0x10 — модераторские действия над комментариями (карма, скрытие) */
    MODERATE_COMMENTS: 16,
    /** 0x40 — комментарии развёрнуты по умолчанию */
    SHOW_COMMENTS: 64,
};
/** Тип баннера для `aa` (Android Q0.q → type 1). */
exports.SiteAdvertisingBannerType = {
    ARTICLE: 1,
};
/** Битовая маска поля [2] комментария сайта (Android Q0.n.f913c) */
exports.CommentFlags = {
    /** 0x02 — комментарий удалён (Android: «(Комментарий удален)») */
    DELETED: 2,
    /** 0x04 — текст скрыт модератором */
    HIDDEN: 4,
    /** 0x10 — модератор уже поставил «плюс в карму» */
    KARMA_VOTED: 16,
};
/** Обновить flags после успешного sk (как Q0.java f913c |= …). */
function applySiteCommentVoteFlags(flags, vote) {
    if (vote === -1) {
        return flags | exports.CommentFlags.HIDDEN | exports.CommentFlags.KARMA_VOTED;
    }
    return flags | exports.CommentFlags.KARMA_VOTED;
}
function isSiteCommentDeleted(flags, id = 0) {
    return id === 0 || (flags & exports.CommentFlags.DELETED) !== 0;
}
function isSiteCommentHidden(flags) {
    return (flags & exports.CommentFlags.HIDDEN) !== 0;
}
function isSiteCommentKarmaVoted(flags) {
    return (flags & exports.CommentFlags.KARMA_VOTED) !== 0;
}
/** Битовая маска поля [2] опроса статьи (Android Q0.s.f919c / ForPDA ArticlePoll.flag) */
exports.ArticlePollFlags = {
    /** 0x01 — один вариант ответа (radio) */
    SINGLE_CHOICE: 1,
    /** 0x02 — несколько вариантов (checkbox) */
    MULTIPLE_CHOICE: 2,
    /** 0x04 — показывать результаты / пользователь уже голосовал */
    VOTED: 4,
};
function isArticlePollSingleChoice(flags) {
    return (flags & exports.ArticlePollFlags.SINGLE_CHOICE) !== 0;
}
function isArticlePollMultipleChoice(flags) {
    return (flags & exports.ArticlePollFlags.MULTIPLE_CHOICE) !== 0;
}
function isArticlePollVoted(flags) {
    return (flags & exports.ArticlePollFlags.VOTED) !== 0;
}
/** flags=0 — legacy-опрос: в Android варианты disabled, голосовать нельзя */
function isArticlePollLegacy(flags) {
    return flags === 0;
}
function shouldShowArticlePollResults(flags) {
    return isArticlePollVoted(flags) || isArticlePollLegacy(flags);
}
function canVoteArticlePoll(flags) {
    if (isArticlePollVoted(flags) || isArticlePollLegacy(flags))
        return false;
    return isArticlePollSingleChoice(flags) || isArticlePollMultipleChoice(flags);
}
